import React from "react";
import { Box, Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface TimeSeriesErrorProps {
  onRefresh?: () => void;
  children?: React.ReactNode;
}

const TimeSeriesError: React.FC<TimeSeriesErrorProps> = ({ onRefresh, children }) => {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "200px", textAlign: "center" }}
    >
      <Box display="flex" alignItems="center" mb={1}>
        <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
        <Typography variant="subtitle2">Error loading data</Typography>
      </Box>
      <Typography variant="caption" mb={2}>
        Something went wrong and we were unable to load the requested data
      </Typography>
      {children ??
        (onRefresh && (
          <Button variant="contained" color="secondary" onClick={onRefresh}>
            Refresh Graph
          </Button>
        ))}
    </Box>
  );
};

export default TimeSeriesError;
